import { render, staticRenderFns } from "./PauseSetting.vue?vue&type=template&id=2da6878a"
import script from "./PauseSetting.vue?vue&type=script&lang=js"
export * from "./PauseSetting.vue?vue&type=script&lang=js"
import style0 from "./PauseSetting.vue?vue&type=style&index=0&id=2da6878a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports